<template>

  <div class="view-contanier">
    <div class="setting-box">
      <!-- <div class="setting-title">邮箱设置</div> -->
      <div class="setting-header">
        <div>
          <div>邮件供应商</div>
          <div v-if="Object.keys(currentService).length > 0">
            <img :src="currentService.logoPath" :alt="currentService.serviceName">
          </div>
          <div v-else>
            --
          </div>
        </div>
        <div>
          <div>邮箱账号</div>
          <div v-if="Object.keys(currentService).length > 0">
            <i class="el-icon-message"></i> {{ currentService.email }}
          </div>
          <div v-else>
            --
          </div>
        </div>
        <!-- <div>
          <div>邮箱密码</div>
          <div v-if="Object.keys(currentService).length > 0">
            <i class="el-icon-lock"></i> {{ currentService.passWord }}
          </div>
          <div v-else>
            --
          </div>
        </div> -->
        <div>
          <el-popover placement="bottom" trigger="click">
            <div class="account-list">
              <div v-for="item in emailServiceList" :key="item.id" class="account-item" @click="changeAcount(item)">
                <div>{{ item.email }}</div>
                <div v-if="item.isActived" class="curr-account">当前</div>
              </div>
              <div class="add-account" @click="dialogVisible=true">
                <i class="el-icon-circle-plus-outline"></i>
                添加账户
              </div>
            </div>
            <el-button slot="reference" size="small">
              <i class="el-icon-s-operation"></i>
              更换邮箱
            </el-button>
          </el-popover>
        </div>
      </div>
    </div>
    <div class="email-floder">
      <div class="email-floder-tab">
        <div :class="folderTab===0?'tab-actived':''" @click="folderTab=0">文件管理</div>
        <div :class="folderTab===1?'tab-actived':''" @click="folderTab=1">签名设置</div>
      </div>
      <div v-if="folderTab===0" v-loading="loading" class="email-floder-section">

        <div v-for="(item,index) in currentService.folderList" :key="index" class="folder-item" @contextmenu.prevent="onContextMenu($event,item)">
          <div>
            <svg-icon className="folder" iconClass="folder"></svg-icon>
          </div>
          <div v-if="!menu.isReName">{{ item.folderName }}</div>
          <div v-if="menu.isReName">
            <input v-model="item.folderName" style="width:100%;border:1px solid #f1f1f1;" @keyup.enter="folderReName" />
          </div>
        </div>

        <!-- 右键菜单 -->
        <ul
          v-show="menu.visible"
          class="context-menu"
          :style="{
            left: menu.x + 'px',
            top: menu.y + 'px'
          }"
          @click="hideMenu">
          <li @click="handle('delete')">删除文件夹</li>
          <li @click="handle('rename')">重命名</li>
          <li @click="handle('view')">查看</li>
          <li @click="handle('update')">修改文件夹</li>
          <li @click="handle('add')">新增文件夹</li>
        </ul>

        <!-- 文件夹查看 -->
        <div
          v-show="menu.detailVisible"
          class="folder-view"
          :style="{
            left: menu.x + 'px',
            top: menu.y + 'px'
          }">
          <el-button icon="el-icon-close" size="small" circle class="close" @click="hideDetailMenu"></el-button>
          <div class="folder-view-header">
            <div class="folder-view-header-left">
              <svg-icon className="folder" iconClass="folder"></svg-icon>
            </div>
            <div class="folder-view-header-right">
              <div>{{ currentFolder.folderName }}</div>
              <div>
                <div><span>创建时间：</span>{{ currentFolder.createdOn }}</div>
                <div><span>邮件数量：</span>{{ currentFolder.emailCount }}</div>
              </div>
            </div>
          </div>
          <div class="folder-view-section">
            <div>{{ currentFolder.folderRuleTypeName }}</div>
            <div>
              <div v-for="(item,index) in currentFolder.ruleList" :key="index">{{ item.ruleName }}</div>
            </div>
          </div>
        </div>
        <el-empty v-if="!this.currentService.folderList || this.currentService.folderList.length===0" style="width:100%" description="暂无文件夹">
          <el-button type="primary" style="background:#5753e8;border-color:#5753e8;" size="small" @click="handle('add')">立即创建</el-button>
        </el-empty>
      </div>
      <div v-else class="email-floder-section email-flode-signature">
        <div>
          <vue-editor
            ref="editor"
            v-model="signature.content"
            :editor-toolbar="customToolbar"
            class="email-editor"
            @ready="onEditorReady"
          />
        </div>
        <div>
          <div>
            <el-switch v-model="signature.isActived" active-text="启用签名"> </el-switch>
          </div>
          <div>
            <el-button size="small" type="primary" :loading="signatureLoading" class="send" style="border-color:#1258bc;background:#1258bc;" @click="saveSignature">保存</el-button>
          </div>
        </div>
      </div>
    </div>
    <addAccountDialogVue :dialogVisible="dialogVisible" @cancel="cancel" />
    <addFolderDialog :dialogVisible="folderDialogVisible" :currentFolder="currentFolder" @cancel="folderCancel" />
  </div>

</template>

<script>
import { Empty } from 'element-ui'
import { VueEditor } from 'vue2-editor'
import { getEmailServiceSettingList, activeEmailAccount, deleteFolder, folderReName, addOrUpdateSignature } from '@/api/email'
import addAccountDialogVue from './components/addAccountDialog.vue'
import addFolderDialog from './components/addFolderDialog.vue'

export default {
    components: {
        addAccountDialogVue,
        addFolderDialog,
        [Empty.name]: Empty,
        VueEditor
    },
  data() {
    return {
        loading: false,
        emailServiceList: [],
        currentService: {},
        dialogVisible: false,
        signature: {
            isActived: false,
            content: ''
        },
        signatureLoading: false,
         menu: {
            visible: false,
            detailVisible: false,
            isReName: false,
            x: 0,
            y: 0
        },
        folderDialogVisible: false,
        currentFolder: {},
        folderTab: 0,
        customToolbar: [
            [{ 'font': [] }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'direction': 'rtl' }],
            [{ 'align': [] }],
            ['link', 'image', 'formula'], // 不包含视频
            ['clean']
        ]
    }
  },
  async mounted() {
    await this.getEmailServiceList(true)
    document.addEventListener('click', this.hideMenu)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.hideMenu)
  },
  methods: {
    onEditorReady(quill) {
        const editorEl = this.$refs.editor.$el.querySelector('.ql-editor')
        if (!editorEl) return

        editorEl.addEventListener('dragover', (e) => {
            e.preventDefault()
            e.dataTransfer.dropEffect = 'copy'
        })

        editorEl.addEventListener('drop', (e) => {
            e.preventDefault()
            const files = Array.from(e.dataTransfer.files).filter(f => f.type.startsWith('image/'))
            if (files.length === 0) return

            files.forEach(file => {
                const reader = new FileReader()
                reader.onload = (event) => {
                    const range = quill.getSelection(true)
                    quill.insertEmbed(range.index, 'image', event.target.result)
                    quill.setSelection(range.index + 1)
                }
                reader.readAsDataURL(file)
            })
        })
    },
    async saveSignature() {
        await addOrUpdateSignature(this.signature).then((res) => {
            if (res.success) {
                this.$message.success('签名设置成功')
            } else {
                this.$message.error(res.errorMessage)
            }
        })
    },
    async getEmailServiceList(isOpen=false) {
        this.loading = true
        await getEmailServiceSettingList().then((res) => {
            if (res.success) {
                if (res.data.length === 0) {
                    // 提示配置邮箱
                    if(isOpen===true)
                        this.dialogVisible = true
                } else {
                    this.emailServiceList = res.data

                    // 获取已激活的账户
                    const obj = this.emailServiceList.find(x => x.isActived)
                    if (obj) {
                        this.currentService = obj

                        if (obj.signature) {
                            this.signature.content = obj.signature.content ?? ''
                            this.signature.isActived = obj.signature.isActived ?? false
                        }
                    }

                    console.log(this.emailServiceList, this.currentService)
                }
            } else {
                this.$message.error(res.errorMessage)
            }
            this.loading = false
        })
    },
    async cancel() {
        this.dialogVisible = false
        await this.getEmailServiceList()
    },
    async changeAcount(item) {
        if (item.isActived === false) {
            // 切换账户
            await activeEmailAccount({ id: item.accountId }).then(async res => {
                if (res.success) {
                    await this.getEmailServiceList()
                    this.$message.success('邮箱已切换, 3S后自动刷新')
                    this.$nextTick(() => {
                        setTimeout(() => {
                        window.location.reload()
                        }, 3000)
                    })
                } else {
                    this.$message.error(res.errorMessage)
                }
            })
        }
    },

    async folderCancel() {
        this.folderDialogVisible = false
        await this.getEmailServiceList()
    },
    async folderReName() {
        await folderReName({ id: this.currentFolder.id, folderName: this.currentFolder.folderName }).then(res => {
             if (res.success) {
                this.menu.isReName = false
                this.$message.success('文件夹已重命名')
            } else {
                this.$message.error(res.errorMessage)
            }
        })
    },
    // 右键
    onContextMenu(e, folder) {
      this.currentFolder = folder
      this.menu.visible = true
      this.menu.x = e.clientX
      this.menu.y = e.clientY
      this.menu.detailVisible = false
    },
    hideMenu() {
      this.menu.visible = false
    },
    hideDetailMenu() {
      this.menu.detailVisible = false
    },
    handle(action) {
      if (action === 'add') {
        this.folderDialogVisible = true
        this.currentFolder = {
            id: -1,
            emailAccountId: this.currentService.accountId
        }
      } else if (action === 'update') {
        if (Object.keys(this.currentFolder).length === 0 || this.currentFolder.id === -1) {
            this.$message.error('请选择一项文件夹')
            return
        }
        this.folderDialogVisible = true
      } else if (action === 'delete') {
        if (Object.keys(this.currentFolder).length === 0 || this.currentFolder.id === -1) {
            this.$message.error('请选择一项文件夹')
            return
        }
        this.$confirm('此操作将永久删除该文件夹, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async() => {
            await deleteFolder({ folderId: this.currentFolder.id }).then(async res => {
                if (res.success) {
                    await this.getEmailServiceList()
                } else {
                    this.$message.error(res.errorMessage)
                }
            })
        }).catch(() => {})
      } else if (action === 'view') {
        if (Object.keys(this.currentFolder).length === 0 || this.currentFolder.id === -1) {
            this.$message.error('请选择一项文件夹')
            return
        }
        this.menu.detailVisible = true
      } else if (action === 'rename') {
        if (Object.keys(this.currentFolder).length === 0 || this.currentFolder.id === -1) {
            this.$message.error('请选择一项文件夹')
            return
        }
        this.menu.isReName = true
      }
      this.hideMenu()
    }
  }
}
</script>

<style lang="less"  scoped>
.email-floder{
    padding: 10px;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    box-shadow: 0 0 2px 2px #e2e2e2;
    border-radius: 5px;
    margin: 10px;
}
.email-floder-tab{
    display: flex;
    font-weight: bold;
    font-size: 15px;
    >div{
        margin-right: 10px;
        cursor: pointer;
        padding:5px 10px;
    }
    .tab-actived{
        color: #1258bc;
    }
}
.email-floder-section{
    display: flex;
    flex: 1;
    padding: 20px;
    overflow: auto;
    position: relative;
}
.email-flode-signature{
    display: flex;
    flex-direction: column;
    padding: 10px;
    overflow: hidden;
    min-height: 0;

    >div:first-child{
        flex: 1;
        min-height: 0;
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }

    >div:last-child{
        display: flex;
        align-items: center;
        justify-content: center;

        >div:first-child{
            flex:1;
        }
    }

}

/deep/ .email-editor{
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: auto;

    .ql-toolbar.ql-snow{
        flex-shrink: 0;
    }

    .ql-container.ql-snow{
        flex: 1;
        min-height: 0;
    }

    .ql-editor{
        overflow-y: auto;
        height: 100%;
    }
}

/deep/ .ql-container.ql-snow{
    border:none;
}

/deep/ .ql-toolbar.ql-snow{
    border:none;
}

/* 工具提示 */
/deep/ .ql-toolbar.ql-snow .ql-formats {
    button, .ql-picker-label {
        position: relative;

        &::after {
            content: attr(data-tooltip);
            position: absolute;
            bottom: 100%;
            left: 50%;
            transform: translateX(-50%);
            padding: 4px 8px;
            font-size: 12px;
            color: #fff;
            background: #333;
            border-radius: 4px;
            white-space: nowrap;
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.2s;
            z-index: 10000;
        }

        &:hover::after {
            opacity: 1;
        }
    }
}

/deep/ .ql-bold { &::after { content: '加粗' !important; } }
/deep/ .ql-italic { &::after { content: '斜体' !important; } }
/deep/ .ql-underline { &::after { content: '下划线' !important; } }
/deep/ .ql-strike { &::after { content: '删除线' !important; } }
/deep/ .ql-script[value="sub"] { &::after { content: '下标' !important; } }
/deep/ .ql-script[value="super"] { &::after { content: '上标' !important; } }
/deep/ .ql-direction[value="rtl"] { &::after { content: '文字方向' !important; } }
/deep/ .ql-clean { &::after { content: '清除格式' !important; } }
/deep/ .ql-link { &::after { content: '插入链接' !important; } }
/deep/ .ql-image { &::after { content: '插入图片' !important; } }
/deep/ .ql-formula { &::after { content: '插入公式' !important; } }
/deep/ .ql-list[value="ordered"] { &::after { content: '有序列表' !important; } }
/deep/ .ql-list[value="bullet"] { &::after { content: '无序列表' !important; } }
/deep/ .ql-indent[value="-1"] { &::after { content: '减少缩进' !important; } }
/deep/ .ql-indent[value="+1"] { &::after { content: '增加缩进' !important; } }

/deep/ .ql-font .ql-picker-label { &::after { content: '字体' !important; } }
/deep/ .ql-size .ql-picker-label { &::after { content: '字号' !important; } }
/deep/ .ql-header .ql-picker-label { &::after { content: '标题' !important; } }
/deep/ .ql-color .ql-picker-label { &::after { content: '字体颜色' !important; } }
/deep/ .ql-background .ql-picker-label { &::after { content: '背景颜色' !important; } }
/deep/ .ql-align .ql-picker-label { &::after { content: '对齐方式' !important; } }

.folder-item{
    border-radius: 5px;
    padding: 10px;
    height: 60px;
    width: 60px;
    margin: 10px;
    text-align: center;
    >div:first-child .folder{
        font-size: 40px;
    }
    >div:last-child{
        margin-top: 10px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        font-size: 12px;
    }

    &:hover{
        background: #f1f1f1;
        cursor: pointer;
    }
}
.actived{
    background: #f1f1f1;
}

.folder-view{
    position: fixed;
    width: 500px;
    box-shadow: 0 0 1px 1px #e2e2e2;
    border-radius: 5px;
    background: white;
    padding: 15px;
    font-size: 12px;

    .close{
        position: absolute;
        right: 10px;
        top: 10px;
        font-size: 15px;
        border:none;
    }

    .folder-view-header{
        display: flex;

        .folder{
            font-size: 70px;
        }
        .folder-view-header-right{
            display: flex;
            justify-content: center;
            flex-direction: column;
            margin-left: 10px;
        }
        .folder-view-header-right >div:last-child{
            display: flex;
            margin-top: 10px;
            >div:first-child{
                margin-right: 20px;
            }

            span{
                color:gray;
            }
        }
        .folder-view-header-right >div:first-child{
            font-size: 16px;
            font-weight: bold;
        }
    }
    .folder-view-section{
        margin-top: 15px;
        max-height: 300px;
        overflow: auto;

        >div:first-child{
            font-weight: bold;
            font-size: 12px;
        }

        >div:last-child{
            margin-top: 10px;
            line-height: 20px;
        }
    }
}

.context-menu {
  position: fixed;
  z-index: 9999;
  min-width: 140px;
  background: white;
  border-radius: 6px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  list-style: none;
  padding: 6px 0;
  user-select: none;

  li {
    padding: 8px 16px;
    cursor: pointer;
    font-size: 13px;

    &:hover {
      background: #e2e2e2;
    }
  }
}

.view-contanier{
    background: white;
    height: calc(100vh - 75px);
    display: flex;
    flex-direction: column;
}
.setting-box{
    padding: 10px;
}
.setting-title{
    font-size: 15px;
    font-weight: 800;
}
.setting-header{
    display: flex;
    box-shadow: 0 0 2px 2px #e2e2e2;
    border-radius: 5px;
    padding: 20px;
    margin-top: 10px;
    >div{
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 220px;
    }
    >div:last-child{
        flex: 1;
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
    }
    >div:last-child>div i{
        margin-right: 5px;
    }

    >div>div:last-child{
        margin-top: 20px;
        font-size: 15px;
    }
    >div>div:last-child i{
        font-size: 15px;
    }
    >div>div:first-child{
        font-weight: bold;
    }
    img{
        width: 120px;
        height: 30px;
        object-fit: cover;
    }
}

.account-item{
    display: flex;
    padding: 10px;
    cursor: pointer;

    >.curr-account{
        margin-left: 10px;
        font-size: 10px;
        background: #2395f3;
        color: white;
        padding: 2px 10px;
        border-radius: 5px;
        text-align: center;
    }
}
.account-item:hover{
    color: #2395f3;
}
.add-account{
    padding: 2px 10px;
    cursor: pointer;
}
.add-account:hover{
    color: #2395f3;
}
</style>
